(() => {
  const INDIA_STORE_URL = 'https://knya.in';
  const SESSION_KEY = 'geoRedirectHandled';
  const UAE_COUNTRY = 'AE';

  const banner = document.getElementById('geo-redirect-banner');
  const yesBtn = document.getElementById('geo-redirect-yes');
  const noBtn = document.getElementById('geo-redirect-no');
  const storeLink = document.getElementById('geo-redirect-store-link');
  const countryEl = document.getElementById('geo-redirect-country');
  const flagEl = document.getElementById('geo-redirect-flag');

  if (!banner || sessionStorage.getItem(SESSION_KEY)) return;

  async function getVisitorCountry() {
    const response = await fetch(`${window.location.origin}/browsing_context_suggestions.json`);
    const result = await response.json();
    const country = result?.detected_values?.country;

    return {
      handle: country?.handle?.toUpperCase() || null,
      name: country?.name || null,
    };
  }

  function shouldShowBanner(country) {
    return Boolean(country?.handle) && country.handle !== UAE_COUNTRY && !sessionStorage.getItem(SESSION_KEY);
  }

  function updateBannerContent(country) {
    const label = country.name || country.handle;
    countryEl.textContent = label;
    flagEl.hidden = false;
    flagEl.src = `https://cdn.shopify.com/static/images/flags/${country.handle.toLowerCase()}.svg?width=32`;
    flagEl.alt = label;
    flagEl.onerror = () => {
      flagEl.hidden = true;
    };
  }

  function showBanner() {
    banner.hidden = false;
    banner.setAttribute('aria-hidden', 'false');
    banner.classList.add('is-visible');
  }

  function hideBanner() {
    banner.classList.remove('is-visible');
    banner.hidden = true;
    banner.setAttribute('aria-hidden', 'true');
  }

  function redirectToIndiaStore() {
    sessionStorage.setItem(SESSION_KEY, 'true');
    window.location.href = INDIA_STORE_URL;
  }

  function bindEvents() {
    yesBtn.addEventListener('click', redirectToIndiaStore);
    noBtn.addEventListener('click', () => {
      sessionStorage.setItem(SESSION_KEY, 'true');
      hideBanner();
    });
    storeLink.addEventListener('click', (e) => {
      e.preventDefault();
      redirectToIndiaStore();
    });
  }

  async function initGeoRedirect() {
    try {
      const country = await getVisitorCountry();
      if (!shouldShowBanner(country)) return;

      updateBannerContent(country);
      bindEvents();
      showBanner();
    } catch (error) {
      console.log('error', error);
    }
  }

  initGeoRedirect();
})();
